import { compose, lifecycle, withState } from 'recompose';

import { fetchShopMembershipsStats } from '../actions';
import withActiveUserIdAndType from '../../../common/hoc/withActiveUserIdAndType';

const MembershipsStatsContainer = compose(
  withActiveUserIdAndType(),
  withState('stats', 'setStats', null),
  lifecycle({
    async componentDidMount() {
      const stats = await fetchShopMembershipsStats(this.props.activeId);
      this.props.setStats(stats);
    },
  }),
);

export default MembershipsStatsContainer;
